import api from './api';
import { GeoLogListResponse } from '../types';

export interface GeoLogFiltros {
  tipo?: string;
  valido?: string;
  dni?: string;
  reglaRechazo?: string;
  desde?: string;
  hasta?: string;
  page?: number;
  limit?: number;
}

export const getGeoLogs = (filtros?: GeoLogFiltros) =>
  api.get<GeoLogListResponse>('/geo-logs', { params: filtros });
